// extracted by mini-css-extract-plugin
export var labelWrapper = "_gw-0";